// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPlan
 */
export interface SubscriptionPlan {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPlan
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    amountDecimal?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    interval?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPlan
     */
    intervalCount?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPlan
     */
    nickname?: string;
}

export function SubscriptionPlanFromJSON(json: any): SubscriptionPlan {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'amountDecimal': !exists(json, 'amount_decimal') ? undefined : json['amount_decimal'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'intervalCount': !exists(json, 'interval_count') ? undefined : json['interval_count'],
        'nickname': !exists(json, 'nickname') ? undefined : json['nickname'],
    };
}

export function SubscriptionPlanToJSON(value?: SubscriptionPlan): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'active': value.active,
        'amount': value.amount,
        'amount_decimal': value.amountDecimal,
        'currency': value.currency,
        'interval': value.interval,
        'interval_count': value.intervalCount,
        'nickname': value.nickname,
    };
}


